export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: 'd533752f-a661-496f-82d2-0c2ba23e83cc',
      authority: 'https://login.microsoftonline.com/6c6faf78-2920-4cab-8820-df3254e685bd',
    },
  },
  apiConfig: {
    scopes: ['api://ea38d1cb-c33b-4e23-b46f-0a0f3562aceb/tmaas.mm.inno'],
    uri: 'https://api.aae-hub-inno-sandbox.com',
  },
  webSocketConfig: {
    uri: 'wss://ws.aae-hub-inno-sandbox.com',
  },
};
